import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Tag, Heading, Lead, PageHero, Section, BtnPrimary } from '../components/UI';
import { SECTIONS } from '../data/servicesSections';
import styles from './AppDev.module.css';

function DocContent({ s }) {
  return (
    <div className={styles.docPanel}>
      <h3 className={styles.docTitle}>{s.t}</h3>
      {s.p.map((para, i) => (
        <p key={i} className={styles.docParagraph}>{para}</p>
      ))}
      {s.leadIn && <p className={styles.docLeadIn}>{s.leadIn}</p>}
      {s.bullets && (
        <ul className={styles.docBullets}>
          {s.bullets.map((b, i) => (
            <li key={i} className={styles.docBulletItem}>
              <span className={styles.docBulletDot} />
              {b}
            </li>
          ))}
        </ul>
      )}
      {s.note && <p className={styles.docNote}>{s.note}</p>}
    </div>
  );
}

export default function AppDev() {
  const location = useLocation();
  const [activeN, setActiveN] = useState(location.state?.section ?? null);
  const active = SECTIONS.find((s) => s.n === activeN);
  const panelRef = useRef(null);

  useEffect(() => {
    if (location.state?.section) {
      setActiveN(location.state.section);
      setTimeout(() => {
        panelRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 50);
    }
  }, [location.state]);

  return (
    <>
      <PageHero
        tag="Services"
        title="Description of Services"
        subtitle="Metawave Solutions LLC provides coordination, facilitation and services designed to assist individuals, professionals, organizations, and other clients with general technology-related learning, professional development, career development, and skills-enhancement needs."
      />

      {/* ── Overview ───────────────────────────────────────────── */}
      <Section variant="paper">
        <Tag>Overview</Tag>
        <Heading>How Our Services Work</Heading>
        <Lead>
          The nature, scope, and availability of services may vary depending on the requirements of the client and
          the terms agreed upon between Metawave Solutions LLC and the client. Metawave Solutions LLC may provide
          certain services directly and may also coordinate, facilitate, or arrange for qualified independent
          third-party professionals, instructors, consultants, or service providers to provide certain portions of
          the services.
        </Lead>
      </Section>

      {/* ── Full Description of Services ──────────────────────── */}
      {active && (
        <Section variant="white">
          <div ref={panelRef}>
            <Tag>Full Description</Tag>
            <Heading>Description of Services</Heading>
            <DocContent s={active} />
          </div>
        </Section>
      )}

      {/* ── CTA ────────────────────────────────────────────────── */}
      <Section variant="paper" style={{ textAlign: 'center' }}>
        <Tag>Get Started</Tag>
        <Heading>Have Questions About Our Services?</Heading>
        <Lead style={{ margin: '0 auto 2rem' }}>
          Reach out to discuss which services fit your organization's or your own professional-development needs.
        </Lead>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <BtnPrimary to="/contact-us">Contact Us &rarr;</BtnPrimary>
          <Link to="/terms-and-conditions" className={styles.btnDarkOutline}>Read Full Terms &amp; Conditions</Link>
        </div>
      </Section>
    </>
  );
}
